var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var sortByAmount = function (certificatesData, sortDirection) {
    return certificatesData.sort(function (a, b) {
        if (sortDirection === 'asc') {
            return (Number(a.certificateIssuedAmount) - Number(b.certificateIssuedAmount));
        }
        return Number(b.certificateIssuedAmount) - Number(a.certificateIssuedAmount);
    });
};
export var sortByStatus = function (certificatesData, sortDirection) {
    return certificatesData.sort(function (a, b) {
        var x = a.certificateStatus.toLowerCase();
        var y = b.certificateStatus.toLowerCase();
        if (sortDirection === 'asc') {
            return x > y ? -1 : 1;
        }
        if (sortDirection === 'desc') {
            return x > y ? 1 : -1;
        }
        return 0;
    });
};
export var sortByDate = function (certificatesData, sortDirection) {
    return certificatesData.sort(function (a, b) {
        var dateA = a.certificateStatus === 'EXPIRED'
            ? new Date(a.certificateExpiryDate).getTime()
            : new Date(a.certificateStatusDate).getTime();
        var dateB = b.certificateStatus === 'EXPIRED'
            ? new Date(b.certificateExpiryDate).getTime()
            : new Date(b.certificateStatusDate).getTime();
        if (sortDirection === 'asc') {
            return dateA - dateB;
        }
        return dateB - dateA;
    });
};
export var filterActiveCertificates = function (certificates) {
    var activeCertificates = __assign({}, certificates);
    var certificateDetailsFilter = certificates === null || certificates === void 0 ? void 0 : certificates.certificateDetails.filter(function (certificate) {
        return certificate.certificateStatus === 'ACTIVE' &&
            Number(certificate.certificateAmount) > 0;
    });
    activeCertificates.certificateDetails = certificateDetailsFilter;
    return activeCertificates;
};
